export const SSO_WELCOME_KEY = 'ssoWelcome';

/**
 * Marks that this browser tab has just created an account through Microsoft sign-in, so the first
 * page of the main app can say welcome. The login app and the main app are separate SPAs on one
 * origin, so session storage is what carries it across the full-page redirect between them.
 */
export function markSsoWelcome(): void {
  try {
    sessionStorage.setItem(SSO_WELCOME_KEY, '1');
  } catch {
    // Storage can be blocked; the welcome is a courtesy, never worth failing a sign-in over.
  }
}

/** True while the marker is set. Reading does not clear it; see {@link clearSsoWelcome}. */
export function hasSsoWelcome(): boolean {
  try {
    return sessionStorage.getItem(SSO_WELCOME_KEY) === '1';
  } catch {
    return false;
  }
}

/** Removes the marker: the welcome was closed, left behind, or the window is going away. */
export function clearSsoWelcome(): void {
  try {
    sessionStorage.removeItem(SSO_WELCOME_KEY);
  } catch {
    // Nothing to clear if storage is unavailable.
  }
}
